import { useEffect, useState, useContext } from 'react'
import { Form, Col, Row, Button, Alert } from 'react-bootstrap'
import axios from 'axios'
import languages from '../config/languages.json'
import qs from "qs";
import { api } from "../services/config"

import { Menu, MenuItem, Typeahead } from 'react-bootstrap-typeahead';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import { checkError } from '../utils/utils';
import { useOutletContext } from 'react-router-dom';
import { ProjectContext } from '../screens/ProjectScreen';

function AddTerm({ type, onClose }) {
    const {
        setProjectState,
        termData, setTermData,
        headers,
    } = useContext(ProjectContext);
    const { profileState } = useOutletContext();
    const { projectRole: { projectId } } = profileState

    let termId = ''
    let surfaceFormDup = ''
    let lemmaDup = ''
    let posTaggingDup = ''
    let langDup = 0
    let formHeadDup = ''
    let formExpDup = ''
    let expTypeDup = ''


    if (type === "duplicateForm") {
        termId = termData.id
        surfaceFormDup = termData.reference
        lemmaDup = termData.form.lemma
        posTaggingDup = termData.form.posTagging
        langDup = termData.form.language
        formHeadDup = !termData.nth_head ? '' : [termData.nth_head.reference]
        formExpDup = !termData.expansion ? '' : [termData.expansion.reference]
        expTypeDup = termData.exp_type
    }

    const [surfaceForm, setSurfaceForm] = useState(surfaceFormDup)
    const [lemma, setLemma] = useState(lemmaDup)
    const [posTagging, setPosTagging] = useState(posTaggingDup)
    const [lang, setLang] = useState(langDup)
    const [formHead, setFormHead] = useState(formHeadDup)
    const [formExp, setFormExp] = useState(formExpDup)
    const [expType, setExpType] = useState(expTypeDup)

    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [validated, setValidated] = useState(false);

    const [terms, setTerms] = useState([])

    const [query, setQuery] = useState()

    const handleInputChange = query => {
        setTerms([])
        setQuery(query);
    };

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        async function fetchTerms(limit = 10, offset = 0) {
            let params = {
                'surface_regex': query ? `(^${query})` : "",
                'sort': (["reference"]),
                'offset': offset,
                'limit': limit
            };
            await axios.get(
                `${api.project}${projectId}/terms/`,
                {
                    params,
                    paramsSerializer: function (params) {
                        return qs.stringify(params, { arrayFormat: "repeat" });
                    },
                },
                { headers }
            )
                .then(res => {
                    setTerms(res.data.terms)
                    setLoading(true)
                })
                .catch(
                    function (error) {
                        return Promise.reject(error)
                    }
                )
        }
        setLoading(false)
        if (query !== undefined && query.length !== 0) fetchTerms()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])




    const onAddShowSuccessMessage = (res) => {
        setShowSuccess(true)
        window.setTimeout(() => {
            setShowSuccess(false)
            toggleAddTermPopup(res.id)
        }, 500)
    };

    const onDuplicateShowSuccessMessage = (res) => {
        setShowSuccess(true)
        window.setTimeout(() => {
            setShowSuccess(false)
            toggleDuplicateTermPopup(res.id)
        }, 500)
    };

    const onShowErrorMessage = () => {
        setShowError(true)
        window.setTimeout(() => {
            setShowError(false)
        }, 2000)
    };

    const surfaceFormHandleChange = (event) => {
        setSurfaceForm(event.target.value)
    }

    const lemmaHandleChange = (event) => {
        setLemma(event.target.value)
    }

    const posTaggingHandleChange = (event) => {
        setPosTagging(event.target.value)
    }

    const formHandleSubmit = event => {
        event.preventDefault();
        const form = {
            reference: surfaceForm,
            headTerm: (formHead[0] !== undefined) ? formHead[0].id : null,
            expansion: (formExp[0] !== undefined) ? formExp[0].id : null,
            exp_type: expType,
            project: projectId,
            language: (lang === 0) ? "unk" : lang,
            lemma: lemma,
            posTagging: posTagging,
        };


        if (surfaceForm !== undefined && surfaceForm !== "") {
            if (type === "addTerm") {
                axios.post(api.project + projectId + '/terms/', form, {
                    headers
                })
                    .then(checkError)
                    .then(res => {
                        onAddShowSuccessMessage(res);
                    })
                    .catch((e) => {
                        onShowErrorMessage();
                    });
            }
            if (type === "duplicateForm") {
                axios.put(`${api.project}${projectId}/terms/${termId}/`, form, {
                    headers
                })
                    .then(checkError)
                    .then(res => {
                        onDuplicateShowSuccessMessage(res);
                    })
                    .catch(() => {
                        onShowErrorMessage();
                    })

            }
        }
        setValidated(true);
    }

    async function toggleDuplicateTermPopup(id) {
        const { data } = await axios.get(`${api.project}${projectId}/terms/${id}`)
        setProjectState(projectState => ({
            ...projectState, refresh: !projectState?.refresh,
        }))
        onClose();
        setTermData(data)
    }

    async function toggleAddTermPopup(id) {
        const { data } = await axios.get(`${api.project}${projectId}/terms/${id}`);
        onClose();
        setProjectState(projectState => ({ ...projectState, refresh: !projectState?.refresh }));
        setTermData(data);
    }

    return (
        <div>
            <Alert className="mx-5" variant="success" show={showSuccess} >
                {type === "duplicateForm" ? "Terme modifié avec succès" : "Terme ajouté avec succès"}
            </Alert>
            <Alert className="mx-5" variant="danger" show={showError} >
                {type === "duplicateForm" ? "Une erreur s'est produite lors de la modification du terme" : "Une erreur s'est produite lors de la création du terme"}
            </Alert>
            {type === "duplicateForm" && <p className='mx-2 center'>Vous êtes sur le point de modifier ce terme, cela signifie qu'une nouvelle forme va être créée pour devenir la forme canonique du terme et que la forme canonique actuelle va devenir une forme remplacée.</p>}
            <Form className="mt-3 mx-5" noValidate validated={validated} >
                <Form.Group as={Row} className="mb-3" controlId="">
                    <Form.Label column sm="4" xs="12">
                        Forme de surface <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Col sm="8" xs="12">
                        <Form.Control required defaultValue={surfaceForm} onChange={surfaceFormHandleChange} />
                        <Form.Control.Feedback type="invalid">
                            Veuillez renseigner ce champ.
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="">
                    <Form.Label column sm="4" xs="12">
                        Langue
                    </Form.Label>
                    <Col sm="8" xs="12">
                        <Form.Control
                            as='select'
                            value={lang}
                            onChange={(e) => setLang(e.target.value)}
                        >
                            <option value=''>Select...</option>
                            {languages.map((language => (
                                <option value={Object.keys(language)}>{Object.values(language)}</option>
                            )))}
                        </Form.Control>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="">
                    <Form.Label column sm="4" xs="12">
                        Lemme
                    </Form.Label>
                    <Col sm="8" xs="12">
                        <Form.Control defaultValue={lemma} onChange={lemmaHandleChange} />
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="">
                    <Form.Label column sm="4" xs="12">
                        POS Tagging
                    </Form.Label>
                    <Col sm="8" xs="12">
                        <Form.Control defaultValue={posTagging} onChange={posTaggingHandleChange} />
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="">
                    <Form.Label column sm="4" xs="12">
                        Tête
                    </Form.Label>
                    <Col sm="8" xs="12">
                        <Typeahead
                            id="search-head"
                            onChange={(data) => { setFormHead(data); setTerms([]) }}
                            renderMenu={(results, menuProps) => (
                                <Menu {...menuProps}>
                                    {results.map((result, index) => (
                                        <MenuItem option={result} position={index}>
                                            <span>
                                                {result.reference}
                                            </span>
                                            <span className="opacity-50 f-s-13 ">
                                                {result?.form?.source?.label}
                                            </span>
                                        </MenuItem>
                                    ))}
                                </Menu>
                            )}
                            labelKey="reference"
                            emptyLabel={!(query !== undefined && query.length !== 0) ? "Commencer à saisir..." : !loading ? "Recherche..." : "Aucune correspondance trouvée"}
                            options={(query !== undefined && query.length !== 0) ? terms : []}
                            onInputChange={handleInputChange}
                            placeholder="Sélectionnez un terme..."
                            selected={formHead || []}
                        />
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="">
                    <Form.Label column sm="4" xs="12">
                        Complément
                    </Form.Label>
                    <Col sm="8" xs="12">
                        <Typeahead
                            id="search-expansion"
                            onChange={(data) => { setFormExp(data); setTerms([]) }}
                            labelKey="reference"
                            renderMenu={(results, menuProps) => (
                                <Menu {...menuProps}>
                                    {results.map((result, index) => (
                                        <MenuItem option={result} position={index}>
                                            <span>
                                                {result.reference}
                                            </span>
                                            <span className="opacity-50 f-s-13 ">
                                                {result?.form?.source?.label}
                                            </span>
                                        </MenuItem>
                                    ))}
                                </Menu>
                            )}
                            emptyLabel={!(query !== undefined && query.length !== 0) ? "Commencer à saisir..." : !loading ? "Recherche..." : "Aucune correspondance trouvée"}
                            options={(query !== undefined && query.length !== 0) ? terms : []}
                            onInputChange={handleInputChange}
                            placeholder="Sélectionnez un terme..."
                            selected={formExp || []}
                        />
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="">
                    <Form.Label column sm="4" xs="12">
                        Position
                    </Form.Label>
                    <Col sm="8" xs="12">
                        <Form.Control
                            as='select'
                            value={expType}
                            onChange={(e) => setExpType(e.target.value)}
                        >
                            <option value=''>Select...</option>
                            <option value='EXP-B'>avant</option>
                            <option value='EXP-F'>après</option>
                        </Form.Control>
                    </Col>
                </Form.Group>
                <div className="text-center"><Button type="submit" onClick={formHandleSubmit}>{type === "duplicateForm" ? "Modifier le terme" : "Ajouter le terme"}</Button></div>

            </Form>
        </div>
    )
}

export default AddTerm